import React from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { useGetCurrency } from 'hooks/useGetCurrency';

import { FormTableExpected } from 'components/_basic/Form/FormTableComponent/components/FormTableExpected';
import { FormTableTotal } from 'components/_basic/Form/FormTableComponent/components/FormTableTotal';
import { useHandleTotalCalculation } from 'components/BusinessToolForm/hooks/useHandleTotalCalculation';
import { GLOBAL_PRODUCTS_NAME } from 'components/BusinessToolForm/Sections/Global/form';
import { IGlobalProductEntity, PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';

import { formatMonetary } from 'helpers/numbers';
import { concatWithDot } from 'helpers/string';

import { IEachUnitTotalProps } from './types';
import { costOfEachUnitPrefix } from '../../../utils/form';
import { COST_OF_EACH_UNIT_FORM_NAMES } from '../../utils/form';

export const EachUnitTotal: React.FC<IEachUnitTotalProps> = ({
  name,
  columns,
  firstColumnWidth,
  disabled,
  onErrorStateChange,
  scrollToElement,
}) => {
  const { t } = useTranslation();
  const currency = useGetCurrency();

  const costOfEachUnitTableTotalName = concatWithDot(
    costOfEachUnitPrefix,
    COST_OF_EACH_UNIT_FORM_NAMES.COST_OF_EACH_UNIT_TABLE_TOTAL,
  );

  const plannedItems: IGlobalProductEntity[] = useWatch({ name: GLOBAL_PRODUCTS_NAME });
  const plannedCosts = plannedItems?.map((item) => item[PRODUCT_NAMES.COST_PER_UNIT]?.toString() ?? '0') || [];

  const expectedPlannedCosts: string[] = plannedItems.map((item) =>
    formatMonetary(item[PRODUCT_NAMES.COST_PER_UNIT]?.toString() ?? '0', currency.value),
  );
  const handleTotalCalculate = useHandleTotalCalculation(costOfEachUnitTableTotalName);

  return (
    <Grid container gap={1.5} marginTop={1.5}>
      <FormTableTotal
        name={name}
        columns={columns}
        expectedTotals={plannedCosts}
        firstColumnWidth={firstColumnWidth}
        disabled={disabled}
        onErrorStateChange={onErrorStateChange}
        onTotalCalculate={handleTotalCalculate}
      />
      <FormTableExpected
        rowHeader={t('financialPlan.plannedExpenses.costOfEachUnit.expectedRowTitle')}
        onHeaderClick={scrollToElement}
        firstColumnWidth={firstColumnWidth}
        columns={expectedPlannedCosts}
      />
    </Grid>
  );
};
